import { AppConfig } from '@launchpad/types';

const config: AppConfig = {
  env: process.env.REACT_APP_ENVIRONMENT || 'dev',
  url: process.env.REACT_APP_URL || 'http://localhost',
  multiCurrency: true,
  showExchangeButton: true,
  currencyFirst: true,
  rdx: true,
  psd2: true
};

export default config;
